import './form';
import './button';
import './textArea';
import '../../scss/components/inlineForm.scss';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-inlineForm";
    ClassNames["JavaScript"] = "js-inlineForm";
    ClassNames["SubmitButton"] = "js-inlineForm_submitButton";
    ClassNames["CancelButton"] = "js-inlineForm_cancelButton";
})(ClassNames || (ClassNames = {}));
